import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { PartnerConfirmationStatus } from '@/models/orders.model';
import { assertUnreachable } from '@/utils';

export const StyledOrderCount = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.NORMAL_GRAY};
`;

const confirmationColor = ($status: PartnerConfirmationStatus) => {
  switch ($status) {
    case PartnerConfirmationStatus.CONFIRMED:
      return COLORS.GREEN;
    case PartnerConfirmationStatus.PARTIAL:
      return COLORS.ORANGE;
    case PartnerConfirmationStatus.UNCONFIRMED:
      return COLORS.NORMAL_GRAY;
    default:
      return assertUnreachable($status);
  }
};

export const StyledConfirmationStatus = styled.span<{ $status: PartnerConfirmationStatus }>`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${({ $status }) => confirmationColor($status)};

  &::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: ${({ $status }) => confirmationColor($status)};
    flex-shrink: 0;
  }
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.5rem;

  .orders-table .ant-table-thead > tr > th:nth-child(1),
  .orders-table .ant-table-tbody > tr > td:nth-child(1) {
    width: 7rem;
  }

  .orders-table .ant-table-thead > tr > th:nth-child(4),
  .orders-table .ant-table-tbody > tr > td:nth-child(4) {
    width: 9rem;
  }

  .orders-table .ant-table-thead > tr > th:nth-child(6),
  .orders-table .ant-table-tbody > tr > td:nth-child(6) {
    width: 10.5rem;
  }

  .orders-table .ant-table-thead > tr > th:nth-child(7),
  .orders-table .ant-table-tbody > tr > td:nth-child(7) {
    width: 9rem;
  }

  .orders-table .ant-table-thead > tr > th:nth-child(10),
  .orders-table .ant-table-tbody > tr > td:nth-child(10) {
    width: 10.5rem;
  }

  .orders-table .ant-table-thead > tr > th .ant-input {
    font-size: 0.75rem;
  }

  .orders-table .ant-table-thead > tr > th .ant-select,
  .orders-table .ant-table-thead > tr > th .ant-select-selector {
    font-size: 0.75rem;
  }

  .orders-table .ant-table-thead > tr > th .ant-picker-input input {
    font-size: 0.75rem;
  }
`;
